import { connectRouter, routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import { createBrowserHistory, History } from 'history';
import { Middleware, Reducer } from 'redux';

export const browserHistory: History = createBrowserHistory();
export const RouterReducer: Reducer = connectRouter(browserHistory);
export const RouterMiddleware: Middleware = createRouterMiddleware(browserHistory);


